<template functional>
  <div style="align-content: center">
    <div
      class="mb-2"
      v-for="(group, index) in props.row.cause_rejected_clusters"
      :key="index"
    >
      <el-tag style="height: auto; color: black; width: 100%" type="info">
        <div class="row pt-2">
          <div class="col-12 col-sm-8 col-lg-5">
            <h6 class="mb-2">
              <strong
                ><translate-text keyTranslate="production.motive" />
                {{ index + 1 }}:</strong
              >
            </h6>
            <p>
              {{ group.name }}
            </p>
          </div>

          <div class="col-12 col-sm-4 col-lg-2">
            <h6 class="mb-2">
              <strong
                ><translate-text keyTranslate="common_words.status" />:</strong
              >
            </h6>
            <div v-if="!group.deleted_at">
              <translate-text keyTranslate="common_words.yes" />
            </div>
            <div v-else>
              <translate-text keyTranslate="common_words.no" />
            </div>
          </div>
        </div>
      </el-tag>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CausesRejectedFormatter',
};
</script>
